import React from 'react';
import { useStyletron } from 'baseui';
import { CustomTheme } from '../baseweb-custom-theme/customTheme';
import Search from 'baseui/icon/search';
import { Button, SHAPE, SIZE } from 'baseui/button';
import { Select, TYPE } from 'baseui/select';
import { AgentListSearchResult } from '../relay-messenger-agents/RelayMessengerAgents';
import { AgentFullName } from '../relay-messenger-axios-service/relay-messenger-axios-service';
import { Delete } from 'baseui/icon';

export type SearchInputAgentsProps = {
  setIsSearchInputOpen: (value: boolean) => void;
  isSearchInputOpen: boolean;
  agentList: AgentListSearchResult[];
  setSearchOptions: (searchOptions: AgentFullName) => void;
};

export const SearchInputAgents = ({
  setIsSearchInputOpen,
  isSearchInputOpen,
  agentList,
  setSearchOptions,
}: SearchInputAgentsProps) => {
  const [css, theme] = useStyletron();
  const customTheme = theme as CustomTheme;
  const [value, setValue] = React.useState([]);

  const placeholder = 'Search by Agent';
  const setSearchOption = (selectedValue: AgentListSearchResult[]) => {
    if (selectedValue) {
      const firstSearchOption = selectedValue[0];
      if (firstSearchOption) {
        setSearchOptions({
          firstName: firstSearchOption.firstName,
          lastName: firstSearchOption.lastName,
        });
      }
    } else {
      setSearchOptions(null);
    }
    setValue([]);
  };

  if (isSearchInputOpen) {
    return (
      <>
        <div
          style={{ position: 'relative', width: '100%', overflow: 'hidden' }}
        >
          <Select
            options={agentList}
            value={value}
            type={TYPE.search}
            placeholder={placeholder}
            onChange={(params) => {
              setValue(params.value as any);
              setSearchOption(params.value as any);
            }}
            overrides={{
              Root: {
                style: ({ $theme }) => ({
                  width: '100%',
                  backgroundColor: 'trasparent',
                  outline: `#00000`,
                }),
              },
              ControlContainer: {
                style: ({ $theme }) => ({
                  backgroundColor: '#FFFFFF',
                  padding: `0px`,
                  paddingRight: '15px',
                }),
              },
              ValueContainer: {
                style: ({ $theme }) => ({
                  paddingLeft: '20px',
                }),
              },
              SearchIconContainer: {
                style: ({ $theme }) => ({
                  left: '5px',
                  padding: `0px`,
                }),
              },
            }}
            maxDropdownHeight="300px"
          />
          <Button
            onClick={() => setIsSearchInputOpen(false)}
            size={SIZE.compact}
            kind={'tertiary'}
            overrides={{
              BaseButton: {
                props: { 'data-testid': 'search-actions-close-btn' },
                style: {
                  position: 'absolute',
                  right: '8px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  zIndex: 1,
                  padding: 0,
                  backgroundColor: 'transparent',
                },
              },
            }}
          >
            <Delete size={20} />
          </Button>
        </div>
      </>
    );
  }

  if (!isSearchInputOpen) {
    return (
      <Button
        onClick={() => setIsSearchInputOpen(true)}
        size={SIZE.compact}
        shape={SHAPE.circle}
        overrides={{
          BaseButton: {
            style: {
              backgroundColor: isSearchInputOpen
                ? '#3693BF'
                : customTheme.colors.white,
              color: isSearchInputOpen ? 'white' : '#3693BF',
              outline: 'none !important',
              ':hover': {
                backgroundColor: '#3693BF',
                color: 'white',
              },
              ':active': {
                backgroundColor: '#3693BF',
                color: 'white',
              },
            },
            props: { 'data-testid': 'search-actions-btn' },
          },
        }}
      >
        <Search size={28} />
      </Button>
    );
  }
};
